module.exports = __webpack_public_path__ + "img/eightday1-3.952abd3f.jpg";